<template>
  <div class="comp-menu">
    <div class="comp-menu-left">
      <component
        :is="item.disabled ? 'div' : 'router-link'"
        :class="{
          'comp-menu-item': true,
          disabled: item.disabled
        }"
        v-for="(item, index) in gong_neng_list"
        :key="index"
        :to="item.url"
        :disabled="item.disabled"
        @click="itemClick(item)"
      >
        <span class="icon iconfont" :class="item.icon" />
        <span class="name">{{ item.key }}</span>
      </component>
    </div>
    <div class="comp-menu-right">
      <div class="flex flex-y-center">
        <div class="comp-menu-item" @click="goNewPage">
          <span class="icon iconfont icon-new-page" />
          <span class="name">新开当页</span>
        </div>
        <div class="comp-menu-item" @click="goRefreshPage">
          <span class="icon iconfont icon-refresh-page" />
          <span class="name">刷新</span>
        </div>
        <div class="comp-menu-item" @click="goBackPage">
          <span class="icon iconfont icon-back-page" />
          <span class="name">返回</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gong_neng_list: [
        {
          key: '客户',
          url: '/new/customer/user',
          icon: 'icon-customer',
          disabled: false
        },
        {
          key: '核算单',
          url: '/new/verify/list',
          icon: 'icon-hesuandan',
          disabled: false
        },
        {
          key: '订单',
          url: '/new/order/list',
          icon: 'icon-dingdan',
          disabled: false
        },
        {
          key: '工程协同',
          url: '/new/gongcheng/list',
          icon: 'icon-gongcheng',
          disabled: false
        },
        {
          key: '工序',
          url: '/new/gongxu/list',
          icon: 'icon-gongxu',
          disabled: false
        },
        {
          key: '工艺',
          url: '/new/gongyi/list',
          icon: 'icon-gongyi',
          disabled: false
        },
        {
          key: '生产班组',
          url: '/new/banzu/list',
          icon: 'icon-banzu',
          disabled: false
        },
        {
          key: '设备',
          url: '/production/she-bei/list',
          icon: 'icon-shebei',
          disabled: false
        },
        {
          key: 'PMC订单',
          url: '/new/pmc/list',
          icon: 'icon-pmcdingdan',
          disabled: false
        },
        {
          key: '采购申请',
          url: '/new/purchase/apply/list',
          icon: 'icon-caigoushenqingdan',
          disabled: false
        },
        {
          key: '送货单',
          url: '/new/delivery/list',
          icon: 'icon-songhuodan-',
          disabled: false
        },
        {
          key: '生产工单',
          url: '/new/renwu/list',
          icon: 'icon-dingdanpaichan',
          disabled: false
        },
        {
          key: '委外工单',
          url: '/new/weiwai/list',
          icon: 'icon-waixiejiagong',
          disabled: false
        },
        {
          key: '库存',
          url: '/new/stock/inventory/list',
          icon: 'icon-warehouse',
          disabled: false
        },
        {
          key: '入库单',
          url: '/new/stock/stockIn/list',
          icon: 'icon-warehouse-in',
          disabled: false
        },
        {
          key: '出库单',
          url: '/new/stock/stockOut/list',
          icon: 'icon-warehouse-out',
          disabled: false
        },
        {
          key: '盘点单',
          url: '/new/stock/stockCheck/list',
          icon: 'icon-pandian',
          disabled: false
        },
        {
          key: '调拨单',
          url: '/new/stock/stockTransfer/list',
          icon: 'icon-tiaobo',
          disabled: false
        },
        {
          key: '收发存',
          url: '/new/stock/inventory/sfc',
          icon: 'icon-shoufacun',
          disabled: false
        }
      ]
    }
  },
  methods: {
    itemClick(item) {
      if (item.disabled) this.$util.moduleLoading(item.key)
    },
    // 新开当前页
    goNewPage() {
      window.open(this.$route.fullPath, '_blank')
    },
    // 刷新当前页
    goRefreshPage() {
      window.location.reload()
    },
    // 返回上一页
    goBackPage() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.comp-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 5px 10px;
  background: @colorWhite;
  border-top: 1px solid @colorGrayD;
  border-bottom: 1px solid @colorGrayD;
  z-index: 99;
  .comp-menu-left {
    display: flex;
    align-items: center;
  }
  .comp-menu-right {
    display: flex;
    align-items: center;
    .el-link--inner {
      display: flex;
      flex-direction: column;
    }
  }
  .comp-menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    text-decoration: none;
    color: @colorGreen;
    background: @colorGreen20;
    border: 2px solid @colorGreen20;
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;
    & ~ .comp-menu-item {
      margin-left: 5px;
    }
    &:hover,
    &.router-link-active {
      color: @colorWhite;
      background: @colorGreen;
      border-color: @colorGreen;
    }
    &.disabled {
      cursor: not-allowed;
      color: @colorGrayDeep;
      background: @colorGrayF;
      border-color: @colorGrayE;
    }
    .icon {
      font-size: 24px;
    }
    .name {
      margin-top: 5px;
      font-weight: bold;
    }
  }
}
</style>
